<script>
    import axios from 'axios';
    import Datepicker from 'vuejs-datepicker';
    import Timepicker from './Timepicker';
    import {it} from 'vuejs-datepicker/dist/locale'

    export default {
        components: {
            'datepicker': Datepicker,
            'timepicker': Timepicker
        },
        name: "stepThree",
        props: {
            'course': Object,
            'dayNames': Array,
            'courseDaysProp': Array,
        },
        data() {
            return {
                courseDays: [],
                intervals: [
                    30, 60, 90, 120, 150, 180, 210, 240
                ],
                showDetailDays: false,
                global: {
                    startTime: {
                        hours: 14,
                        minutes: 0
                    },
                    endTime: {
                        hours: 15,
                        minutes: 0
                    },
                    interval: 30
                },
                it: it,
                loading: false,
                pickerSetting: {
                    headerShow: false,
                },
                message: null,
                validationMessage: null,
                dateValidation: false,
                filteredDayNames: []
            }
        },
        computed: {
            disabledDates() {
                return {
                    to: new Date(this.course.startDate)
                };
            },
        },
        mounted() {
            var self = this;

            this.courseDays = this.courseDaysProp;

            this.dayNames.forEach(d => {
                let selected = this.courseDays.filter(cd => cd.dow == d.dow).length > 0
                this.filteredDayNames.push(Object.assign(d, { selected }))
            })

            if (self.course.startDate && self.course.endDate) {
                setTimeout(function () {
                    $('#startDatePicker').val(moment(self.course.startDate).format('DD/MM/YYYY'))
                    $('#endDatePicker').val(moment(self.course.endDate).format('DD/MM/YYYY'))
                }, 500)
            }

            if (this.course.startDate && this.course.endDate) {
                this.dateValidation = true;
            }
            if (this.courseDays.length > 0) {
                this.courseDays.sort(this.compare)
                this.$set(this.global, 'interval', this.courseDays[0].interval)
                this.groupDaysByTime()
            }
        },
        watch: {
            'global.interval': {
                handler(value) {
                    if (_.isNumber(value)) {
                        this.courseDays.forEach(d => {
                            d.interval = $.extend( {}, value );
                        })
                    }
                }
            },
            'global.startTime': {
                handler(value) {
                    let mStart = new moment(`${value.hours}:${value.minutes}:00`, 'HH:mm:ss')
                    let mEnd = new moment(`${this.global.endTime.hours}:${this.global.endTime.minutes}:00`, 'HH:mm:ss')

                    if (mStart.diff(mEnd, 'minutes') > 0) {
                        this.dateValidation = false;
                    } else {
                        this.dateValidation = true;
                        this.courseDays.forEach(d => {
                            d.startTime = $.extend( {}, value );
                        })
                    }
                },
                deep: true
            },
            'global.endTime': {
                handler(value) {
                    let mEnd = new moment(`${value.hours}:${value.minutes}:00`, 'HH:mm:ss')
                    let mStart = new moment(`${this.global.startTime.hours}:${this.global.startTime.minutes}:00`, 'HH:mm:ss')

                    if (mEnd.diff(mStart, 'minutes') > 0) {
                        this.dateValidation = true;
                        this.courseDays.forEach(d => {
                            d.endTime = $.extend( {}, value );
                        })
                    }
                },
                deep: true
            },
            'course.startDate'() {
                if (this.course.startDate > this.course.endDate) {
                    this.course.endDate = null;
                    this.dateValidation = false;
                }
                else {
                    this.dateValidation = true;
                }
            },
            'course.endDate'() {
                if (this.course.startDate <= this.course.endDate) {
                    this.dateValidation = true;
                }
            },
        },
        methods: {
            groupDaysByTime() {
                let groupStartHours = []
                let groupEndHours = []
                let groupStartMinutes = []
                let groupEndMinutes = []

                this.courseDays.forEach(d => {
                    if (!groupStartHours.includes(d.startTime.hours)) {
                        groupStartHours.push(d.startTime.hours)
                    }
                    if (!groupEndHours.includes(d.endTime.hours)) {
                        groupEndHours.push(d.endTime.hours)
                    }
                    if (!groupStartMinutes.includes(d.startTime.minutes)) {
                        groupStartMinutes.push(d.startTime.minutes)
                    }
                    if (!groupEndMinutes.includes(d.startTime.minutes)) {
                        groupEndMinutes.push(d.endTime.minutes)
                    }
                })
                if (groupStartHours.length === 1 && groupEndHours.length === 1 && groupStartMinutes.length === 1 && groupEndMinutes.length === 1) {
                    this.$set(this.global, 'startTime', {
                        hours: groupStartHours[0],
                        minutes: groupStartMinutes[0]
                    })
                    this.$set(this.global, 'endTime', {
                        hours: groupEndHours[0],
                        minutes: groupEndMinutes[0]
                    })
                } else {
                    this.toggleDetails()
                }
            },
            toggleDetails() {
                this.showDetailDays = !this.showDetailDays
            },
            isLoading() {
                return this.loading;
            },
            dayIsSelected(dow) {
                return this.courseDays.filter(d => d.dow == dow).length > 0
            },
            addTimeSlot(day) {
                let time = {
                    index: day.index,
                    name: day.name,
                    dow : day.dow,
                    shortName: day.shortName,
                    shortNameFull: day.shortNameFull,
                    validationError: false,
                    startTime: $.extend( {}, day.startTime ),
                    endTime: $.extend( {}, day.endTime )
                }
                this.courseDays.push(time);
                this.courseDays.sort(this.compare)
            },
            addTime(day, index) {
                if (!this.filteredDayNames[day.dow].selected) {
                    this.$set(this.filteredDayNames[day.dow], 'selected', true)
                    let time = {
                        index: index,
                        name: day.name,
                        dow : day.dow,
                        shortName: day.shortName,
                        shortNameFull: day.shortNameFull,
                        validationError: false,
                        startTime: this.global.startTime,
                        endTime: this.global.endTime
                    }
                    this.courseDays.push(time);
                    this.courseDays.sort(this.compare)
                } else {
                    this.removeAllTime(day.dow)
                }
            },
            getStartTimeId(day) {
                return Math.random() + 'start' + day.dow
            },
            getEndTimeId(day) {
                return Math.random() + 'end' + day.dow
            },
            removeAllTime(dow) {
                let courseDays = this.courseDays.filter(d => d.dow != dow);
                this.$set(this.filteredDayNames[dow], 'selected', false)
                this.$set(this, 'courseDays', courseDays)
            },
            removeTime(dow, index) {
                this.courseDays.splice(index, 1);

                let d_index  = this.courseDays.map(function (day) { return day.dow; }).indexOf(dow);
                if (!d_index) {
                    this.$set(this.filteredDayNames[dow], 'selected', false)
                }
            },
            validation() {
                this.validationMessage = null;
                if (this.course.startDate > this.course.endDate) {
                    this.validationMessage = 'Start date is later than end date';
                    return false;
                }
                this.courseDays.forEach((day) => {
                    let startTime = new moment(`${day.startTime.hours}:${day.startTime.minutes}:00`, 'HH:mm:ss')
                    let endTime = new moment(`${day.endTime.hours}:${day.endTime.minutes}:00`, 'HH:mm:ss')
                    let duration = endTime.diff(startTime, 'minutes')

                    day.validationError = false;
                    if (this.global.interval != 0 && duration % this.global.interval != 0) {
                        day.validationError = true;
                        this.validationMessage = 'Lessons duration has not a valid interval time';
                    }
                    if (day.startTime.hours === null || day.endTime.minutes === null || day.startTime.hours > day.endTime.hours) {
                        day.validationError = true;
                        this.validationMessage = day.name + ' is invalid.';
                    }
                    else if (day.startTime.hours === day.endTime.hours && day.startTime.minutes >= day.endTime.minutes) {
                        day.validationError = true;
                        this.validationMessage = day.name + ' is invalid.';
                    }
                });
                if (this.validationMessage) {
                    if (!this.showDetailDays) {
                        this.toggleDetails()
                    }
                }
            }
            ,
            previousStep() {
                this.$emit('update-step', 2);
            }
            ,
            postForm() {
                this.validation();

                this.loading = true;
                this.$bus.$emit('searching');

                if (!this.validationMessage) {
                    axios({
                        method: 'put',
                        url: '/courses/' + this.course.courseId + '/dates',
                        data: {
                            courseDates: {
                                'startDate': this.course.startDate,
                                'endDate': this.course.endDate,
                            },
                            courseDays: this.courseDays,
                            interval: this.global.interval
                        }
                    }).then((response) => {
                        this.loading = false;
                        this.$bus.$emit('filtered');
                        this.$emit('update-step', 4);

                    }).catch((error) => {
                        this.loading = false;
                        this.$bus.$emit('filtered');
                        this.message = 'Error';
                    });
                } else {
                    this.loading = false;
                    this.$bus.$emit('filtered');
                }
            },
            compare(a, b) {
                if (a.index < b.index)
                    return -1;
                if (a.index > b.index)
                    return 1;
                return 0;
            },
            dateFormatter(date) {
                return moment(date).format('DD/MM/YYYY', 'it');
            }
        }
    }
</script>
<style>
    .form-day-box > .custom-control-label::before {
        display: none !important;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/course/StepThree.vue